import React, { useState, useEffect} from 'react'
import { useSelector } from 'react-redux'
import { MessageBar } from '@fluentui/react'
import { trimAny } from './helpers/HelperMethods';
import { useHistory } from 'react-router';

const MessageBars = () => {

    const allMessageBars = useSelector(state => state.app.messageBars);
    const [messageBars, setMessageBars] = useState([]);
    const history = useHistory();

    const filterAndSetMessageBars = () => {
        const url = trimAny(document.location.pathname + document.location.hash, '/');
        setMessageBars(allMessageBars.filter(bar => url.startsWith(trimAny(bar.url, '/'))));
    } 

    useEffect(() => {
        filterAndSetMessageBars();
        history.listen(() => {
            filterAndSetMessageBars();
        })
    }, [allMessageBars]);


    return (
        <div>
        {
            messageBars.map((bar, index) => 
                <MessageBar truncated={false} messageBarType={bar.type} key={index} styles={messageBarStyles}>
                    <div dangerouslySetInnerHTML={{__html: bar.content}}></div>
                </MessageBar>
            )
        }
        </div>
    )
}

const messageBarStyles = {
    root: {
        marginTop: 10,
    },
    innerText: {
        fontSize: 14,
        lineHeight: 20
    }
}

export default MessageBars


// WEBPACK FOOTER //
// ./src/MessageBars.js